export default "__VITE_ASSET__CGJwE8nO__"